var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"button-card"},[(_vm.cardTitle)?_c('p',{staticClass:"card-title"},[_vm._v(" "+_vm._s(_vm.$t(_vm.cardTitle))+" ")]):_vm._e(),_c('div',{staticClass:"button-card_content",class:{white:_vm.white}},[_c('p',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.$t(_vm.contentText))+" ")]),_c('div',{staticClass:"btn"},[_vm._t("btn")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }